import { motion } from "framer-motion";
import { Inbox } from "lucide-react";
import { Button } from "@/components/ui/button";

export function EmptyState({ icon: Icon = Inbox, title, message, actionLabel, onAction, testId }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="flex flex-col items-center justify-center rounded-2xl border border-[var(--border-soft)] bg-white px-6 py-14 text-center"
      data-testid={testId || "empty-state"}
    >
      <div className="relative mb-4">
        <div className="absolute inset-0 -z-10 rounded-full blur-2xl" style={{ background: "radial-gradient(circle, rgba(252,219,83,0.35), rgba(248,159,99,0.12) 60%, transparent 70%)" }} />
        <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[var(--surface-2)] border border-[var(--border-soft)]">
          <Icon className="h-7 w-7 text-[var(--shariti-orange)]" />
        </div>
      </div>
      <h3 className="text-lg font-extrabold tracking-tight">{title}</h3>
      {message && <p className="mt-1 max-w-md text-sm text-muted-ink">{message}</p>}
      {actionLabel && (
        <Button onClick={onAction} className="mt-5 bg-[var(--shariti-orange)] text-white hover:bg-[#E56622]" data-testid="empty-state-action">
          {actionLabel}
        </Button>
      )}
    </motion.div>
  );
}
